var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.60449V8.22949H10.875C11.439 8.22949 11.9209 8.59863 12.1055 9.13184L14.5562 31.0034C14.7817 32.9824 16.4839 34.5 18.4731 34.5H34.5V31.875H18.4731C17.7964 31.875 17.2427 31.3828 17.1709 30.7163L17.0068 29.25H33.6592C35.5254 29.25 37.1558 27.917 37.5249 26.0918L40.0371 13.5H15.2329L14.6689 8.49609L14.6279 8.37305C14.1255 6.73242 12.5977 5.61475 10.875 5.60449H5.625ZM31.875 34.5C30.4292 34.5 29.25 35.6792 29.25 37.125C29.25 38.5708 30.4292 39.75 31.875 39.75C33.3208 39.75 34.5 38.5708 34.5 37.125C34.5 35.6792 33.3208 34.5 31.875 34.5ZM18.75 34.5C17.3042 34.5 16.125 35.6792 16.125 37.125C16.125 38.5708 17.3042 39.75 18.75 39.75C20.1958 39.75 21.375 38.5708 21.375 37.125C21.375 35.6792 20.1958 34.5 18.75 34.5ZM15.5303 16.125H36.8379L34.9512 25.5688C34.8179 26.1943 34.2949 26.625 33.6592 26.625H16.7095L15.5303 16.125Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopCartIcon);
export default __webpack_public_path__ + "static/media/shop-cart-icon.094123a19e7743f898853094d6ae4235.svg";
export { ForwardRef as ReactComponent };